import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type CaseNotesEntryPointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const caseNotesEntryPoint: EntryPoint<CaseNotesEntryPointComponent, {}> = createEntryPoint({
	root: JSResourceForUserVisible<CaseNotesEntryPointComponent>(
		/* webpackChunkName: "async-servicedesk-case-management-settings-case-notes" */ './CaseNotesPage.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({}),
});
